<template>
    <client-only>
        <el-popover :width="isDesktop ? 300 : 260"
            :hide-after="0" placement="bottom-end" :trigger="isDesktop ? 'hover' : 'click'"
            v-model="visible" @show="onUpdateUserInfo"
        >
            <template #reference>
                <nuxt-link :to="localePath('/account?meun=user')"class="desktop-user-avatar">
                    <UserAvatar :size="avatarSize" />
                    <!-- <div class="icon-box">
                        <el-image :src="imageMap.vip" v-if="userInfo?.vipLevel === 1"/>
                        <el-image :src="imageMap.svip" v-if="userInfo?.vipLevel === 2"/>
                        <el-image :src="imageMap.free" v-if="userRemark?.vipTrialEndTime"/>
                    </div> -->
                </nuxt-link>
            </template>
            <div class="user-popover-content" :class="{'desktop-user-popover': isDesktop}">
                <nuxt-link :to="localePath('/account?menu=user')">
                    <div class="accountInfo">
                        <UserAvatar :size="36" :defaultSize="36" />
                        <div class="nameEmail">
                            <div class="userInfo_view">
                                <div class="title">{{ userInfo.nickName }}</div>
                            </div>
                            <div class="subTitle">{{ accountEmail }}</div>
                        </div>
                        <div class="arrow">
                            <i class="iconfont icon-icon_arrowsrigh" />
                            <div class="red-point-account" v-if="!userInfo.email || userInfo.setPasswordWarn" />
                        </div>
                    </div>
                </nuxt-link>
                
                <div class="user-container">
                    <TranslateRights />
                </div>
                <div class="menu-container">
                    <div v-for="(item, index) in customeMenu"  :key="item.name || 'default' + index"
                        @click="handleMenuClick(item)"
                    >
                        <div v-if="item.isDivider" class="divider"></div>
                        <div v-else class="account-menu-item">
                            <span class="iconfont" :class="item.icon"></span>
                            <span class="name">{{ item.name }}</span>
                            <span
                                v-if="item.component === AccountMenuEnum.Enterprise && hasPendingInvite"
                                class="enterprise-notice-dot"
                                aria-hidden="true"
                            ></span>
                            <span class="iconfont icon-icon_arrowsrigh"></span>
                        </div>
                    </div>
                </div>
                <!-- <div class="logout-btn" @click="handleLogout">
                    <span class="iconfont icon-icon_exit"></span>
                    <span class="name">退出登录</span>
                </div> -->
            </div>
        </el-popover>
    </client-only>
</template>

<script setup lang="ts">
import useUserStore from '~/store/modules/user';
import type LogoutDialog from '~/components/LogoutDialog/index.vue'
import { hasPendingEnterpriseInvitation } from '~/utils/enterpriseManagement'
const { userInfo, userRemark } = storeToRefs(useUserStore())
const userStore = useUserStore()
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
withDefaults(defineProps<{ avatarSize?: number }>(), {
    avatarSize: 40
})
const localePath = useLocalePath()
const { menu } = useAccountMenu()
const visible = ref(false)
const accountEmail = ref('')
const hasPendingInvite = computed(() => hasPendingEnterpriseInvitation(userInfo.value))

watch(() => userInfo.value, (newQuery, oldQuery) => {
	if (newQuery.accountType && newQuery.accountType === 1){
		accountEmail.value = getReplaceByString(userInfo.value.userAccount, "(google-oauth)")
	}else if (newQuery.accountType && newQuery.accountType === 2){
		accountEmail.value = getReplaceByString(userInfo.value.userAccount, "(apple-oauth)")
	}else {
		accountEmail.value = userInfo.value.userAccount
	}
}, { immediate: true }) // immediate: true 表示立即执行一次

const customeMenu = computed(() => {
    return menu.value
})
const imageMap = {
    vip: new URL('@/assets/images/vip/icon_vip@2x.png', import.meta.url).href,
    svip: new URL('@/assets/images/vip/icon_svip@2x.png', import.meta.url).href,
    free: new URL('@/assets/images/vip/icon_free@2x.png', import.meta.url).href,
}

const router = useRouter()
const route = useRoute()
const handleMenuClick = (item: IAccountMenu)=>{
    visible.value = false
    if (item.component == AccountMenuEnum.ExitLogin) {
        handleLogout()
    } else {
        router.push(item.path as string)
    }
}

const onUpdateUserInfo = ()=>{
    userStore.getUserInfo()
    userStore.getRoleRights()
}

const logoutDialogRef = inject('logoutDialogRef') as Ref<InstanceType<typeof LogoutDialog>>
const handleLogout = ()=>{
    logoutDialogRef.value?.open()
}
</script>

<style lang="scss" scoped>
@use './index.scss' as *;
</style>
